import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { actions as uiActions } from 'state/ui';

import ModalCancelOrder from 'components/ModalCancelOrder/component';

const enhance = compose(
  withTranslation('Orders'),
  connect(() => {}, {
    toggleCancelOrderModalOpened: uiActions.toggleCancelOrderModalOpened,
  }),
  withHandlers(() => ({
    handleClose:
      ({ toggleCancelOrderModalOpened }) =>
      () => {
        toggleCancelOrderModalOpened({ order: false });
      },
  }))
);

export default enhance(ModalCancelOrder);
